import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICompany } from "../../utils/types/models";

export default createEntityReducer<ICompany>(Endpoint.Companies, Endpoint.CompaniesList);
